import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { HttpMethods } from '@app/services/general-settings/http-methods/http-methods';
import { HttpMethodsService } from '@app/services/general-settings/http-methods/http-methods.service';
import { Fields } from '@app/services/selective-processes/fields/fields';
import { PagesEditorService } from '@modules/administration/pages-editor/pages-editor.service';
import { SelectiveEditorService } from '@modules/administration/selective-editor/selective-editor.service';
import { FormUtils } from '@shared/utils/form.utils';
import { SlideToggleValidator } from '@shared/validators/slide-toggle-validator';
import { AddsPareamentsService } from '../adds-pareaments/adds-pareaments.service';
import { DialogComponent } from '../dialog/dialog.component';
import { FormConfigDataSave } from '../dialog/template/dialog-form-config/form-config-data-save-service';
import { LoaderService } from '../loader/loader.service';


@Component({
  selector: 'app-edit-form-data',
  templateUrl: './edit-form-data.html',
  styleUrls: ['./edit-form-data.scss']
})

// tslint:disable: max-line-length
export class EditFormDataComponent implements OnInit, OnDestroy {

  @Input() currentForm;
  @Input() dateField;
  @Input() editorMode;
  @Output() valueChanged = new EventEmitter<any>();


  public manualValues = [];
  public httpMethods: HttpMethods[] = new Array();
  public systemFields: Fields[] = new Array();
  public formulario: FormGroup;
  public parameters: FormArray;
  public parametersTwo: FormArray;
  public currentCheckedValue = null;

  public value =
`{
  "value": 1
}`;

  public valueTwo = `{
    "options": [
      {
        "display": "Titulo",
        "value": 1
      },
      {
        "display": "Titulo 2",
        "value": 2
      }
    ]
  }`;

  constructor(
    private formBuilder: FormBuilder,
    private addsPareamentsService: AddsPareamentsService,
    private selectiveEditorService: SelectiveEditorService,
    private pagesEditorService: PagesEditorService,
    private httpMethodsService: HttpMethodsService,
    private loaderService: LoaderService,
    private dialogComponent: DialogComponent,
    private formConfigDataSave: FormConfigDataSave
  ) {
    this.formulario = this.formBuilder.group({
      data_type: [null],
      data_value: [
        { value: null, disabled: true },
        [
          Validators.required,
          this.checkReservedParameters
        ]
      ],
      predefined_source_options: [false],
      defined_source: [null],
      read_only: [false],
    });
  }

  ngOnInit() {
    this.getHttpMethods();
    this.setExternalSource();
    this.setPredefinedExternalSource();
    if (this.dialogComponent.data.standardFields) {
      this.systemFields = JSON.parse(JSON.stringify(this.dialogComponent.data.standardFields));
    } else if (this.dialogComponent.data.fields) {
      this.systemFields = JSON.parse(JSON.stringify(this.dialogComponent.data.fields));
    }

    const dateForm = FormUtils.switchValueSlideToggleView([
      'predefined_source_options',
      'auto_save',
      'read_only'], {
      data_type: `${this.dateField.data_type}`,
      data_value: this.dateField.data_value,
      auto_save: this.dateField.auto_save,
      predefined_source_options: this.dateField.predefined_source_options,
      defined_source: this.dateField.defined_source,
      read_only: this.dateField.read_only,
    });

    this.changeValueDateField();

    if (this.dateField.manual_options && this.dateField.manual_options.length) {
      const manualValues = this.dateField.manual_options;
      this.formulario.addControl('manual_options', this.createManualSource());
      this.addManualOption(manualValues);
    }

    if (this.editorMode) {
      this.formulario.controls.predefined_source_options.disable();
      this.formulario.controls.defined_source.disable();
      if (this.dateField.manual_options && this.dateField.manual_options.length) {
        this.formulario.controls.manual_options.disable();
      }
    }

    this.formulario.patchValue(dateForm);

    this.formulario.get('predefined_source_options').valueChanges.subscribe(toggle =>{
      if(this.formulario.get('manual_options')){
        for (let i = this.manualValues.length; i >=0; i--) {
          this.removeManualOption(i);
        }
        this.formulario.get('manual_options').reset();

        if(toggle && this.manualValues.length === 0 && this.dateField.defined_source  == 3){
          this.addManualOption();
        }
      }
      
      if(this.formulario.get('predefined_external_source')){
        this.formulario.get('predefined_external_source').reset();
        if(toggle) {
          this.formulario.get('predefined_external_source').enable();
        } else {
          this.formulario.get('predefined_external_source').disable();
        }
      }
    })
  }

  public checkReservedParameters(input) {
    const reservedParameters = ['idPs'];
    const value = input.value;
    const dataType = input.parent.controls.data_type.value;

    if(reservedParameters.includes(value) && dataType == 2) {
      return { reserved : true};
    }

    return null;
  }

  /**
   * changeDataType
   */
  public changeDataType(event) {
    if (event.value === '3') {
      this.formulario.addControl('external_source', this.createExternalSource(0));
    }
  }

  public changeDefinedSource(event) {
    if (event.value === 2) {
      this.formulario.addControl('predefined_external_source', this.createExternalSource(1));
    }else if(this.formulario.get('predefined_external_source')){
        this.formulario.get('predefined_external_source').reset();
    }
    if (event.value === 3) {
      if (this.formulario.get('manual_options')) {
        this.formulario.get('manual_options').enable();
        if (this.manualValues.length === 0) {
          this.addManualOption()
        }
      } else {
        this.formulario.addControl('manual_options', this.createManualSource());
        if (this.manualValues.length === 0) {
          this.addManualOption()
        }
        if (this.editorMode) {
          this.formulario.get('manual_options').disable();
        }
      }
    } else if (this.formulario.get('manual_options')){
      for (let i = this.manualValues.length; i >=0; i--) {
        this.removeManualOption(i);
      }
      this.formulario.get('manual_options').reset();
      this.formulario.get('manual_options').disable();
    }
  }

  public removeManualOption (i) {
    this.formArray.removeAt(i);
    this.manualValues.splice(i, 1);
  }

  public addManualOption(array: Array<any> = [], i:any = null) {
    if(i != null) {
      const manualOptions = [...this.manualValues];
      const newsElements = [Object.assign(manualOptions[i]),{value: '', display: ''}];
      manualOptions.splice(i, 1,...newsElements);
      this.formArray.insert(i + 1,this.formBuilder.group(
        {
          value: ['' ,Validators.required],
          display: ['']
        }
      ));
      this.manualValues = [...manualOptions];
    } else {
      if (array.length === 0) {
        this.formArray.push(this.formBuilder.group(
          {
            value: ['' ,Validators.required],
            display: ['']
          }
          ));
          this.manualValues.push({value: '', display: ''});
      } else {
        array.map((item)=> {
          this.formArray.push(this.formBuilder.group({
            value: [item.value, Validators.required],
            display: [item.display]
          }));
          this.manualValues.push({value: item.value, display: item.display});
        });
      }
    }
  }

  get formArray() {
    return this.formulario.get('manual_options') as FormArray;
  }

  changeValueDateField() {
    this.formulario.valueChanges.subscribe(
      values => {
        this.dateField.data_type = this.setDataType(values.data_type);
        this.dateField.data_value = this.setDataValue(values.data_value);
        this.dateField.defined_source = values.defined_source;
        this.dateField.predefined_source_options = this.switchValueSlideToggleAPI(values.predefined_source_options);
        this.dateField.read_only = this.switchValueSlideToggleAPI(values.read_only);
        this.dateField.external_source = values.external_source ?? null;

        if (!this.editorMode) {
          this.dateField.predefined_external_source = values.predefined_external_source ?? null;
          if (values.predefined_external_source && !values.predefined_external_source.active_paramn) {
            this.dateField.predefined_external_source.parameters = [];
          }
        }

        this.dateField.auto_save = values.external_source ? values.external_source.auto_save : false;

        if (values.manual_options) {
          this.dateField.manual_options = this.getValidOptions(values.manual_options);
        }

        if (values.external_source && !values.external_source.active_paramn) {
          this.dateField.external_source.parameters = [];
        }


        setTimeout(() => {
          this.checkFormValidity(values)
        }, 0);
      }
    );
  }

  checkFormValidity(values) {
    this.formConfigDataSave.setStatusData('VALID');
    this.checkDefaultValueFormValidity(values);
    this.checkPredefinedOptionsFormValidity(values);
  }

  checkDefaultValueFormValidity(values) {
    if (values.data_type == 3) {
      if (this.isDefaultValueExternalSourceFormValid()) {
        this.formConfigDataSave.setStatusData('INVALID');
      }
    } 
    else {
      if (values.data_value === "") {
        this.formConfigDataSave.setStatusData('INVALID');
      }

      if(values.data_type == 2) {
        if (this.isParameterValueFormValid()) {
          this.formConfigDataSave.setStatusData('INVALID');
        }
      }
    }
  }

  isDefaultValueExternalSourceFormValid() {
    return this.formulario.get('external_source') && !this.formulario.get('external_source').valid;
  }

  isParameterValueFormValid() {
    return this.formulario.get('data_value') && !this.formulario.get('data_value').valid;
  }

  checkPredefinedOptionsFormValidity(values) {
    if(!values.predefined_source_options){
      return;
    }
    if (values.defined_source == 2) {
      if (this.isPredefinedOptionsExternalSourceFormValid()) {
        this.formConfigDataSave.setStatusData('INVALID');
      }
    } else if (values.defined_source == 3) {
      if (this.isPredefinedOptionsManualSourceFormValid()) {
        this.formConfigDataSave.setStatusData('INVALID');
      }
    }
  }

  isPredefinedOptionsExternalSourceFormValid() {
    return this.formulario.get('predefined_external_source') && !this.formulario.get('predefined_external_source').valid;
  }

  isPredefinedOptionsManualSourceFormValid() {
    return this.formulario.get('manual_options') && !this.formulario.get('manual_options').valid;
  }

  getValidOptions(manual_options) {
    if (manual_options) {
      const options = manual_options.filter((option)=>{
        if (option.value !== "" && option.display !== "") {
          return option;
        }
      });
      return options;
    }
    return [];
  }

  private switchValueSlideToggleAPI(value: boolean): number {
    if (!value) {
      return 0;
    } else if (value) {
      return 1;
    }
  }


  private setDataValue(value): string {
    if (typeof value === 'undefined') {
      return null;
    } else {
      return value;
    }
  }

  private setDataType(value) {
    if (value === 'null' || typeof value === 'undefined') {
      return null;
    } else {
      return value;
    }
  }

  private setExternalSource() {
    if (this.dateField.external_source) {
    this.dateField.external_source.active_paramn = this.dateField.external_source.parameters.length > 0 ? true : false;
      this.formulario.addControl('external_source', this.formBuilder.group({
        id: this.dateField.external_source.id,
        field_id: this.dateField.external_source.field_id,
        http_methods_type_id: this.dateField.external_source.http_methods_type_id,
        is_predefined_option: 0,
        link: this.dateField.external_source.link,
        auto_save: this.dateField.auto_save,
        parameters: this.formBuilder.array([], SlideToggleValidator.slideToggle()),
        active_paramn: [this.dateField.external_source.parameters.length > 0 ? true : false]
      }));
      if (this.dateField.external_source.parameters.length > 0) {
        this.addsPareamentsService.setValuesParameters(this.dateField.external_source.parameters);
      }
    } else if (this.dateField.data_type == 3) {
      this.formulario.addControl('external_source', this.createExternalSource(0));
      if (this.dateField.auto_save) {
        this.formulario.patchValue(
          {
            external_source: {
              auto_save: true
            }
          }
        )
      }
    }
  }

  private setPredefinedExternalSource() {
    if (this.dateField.predefined_external_source && this.dateField.predefined_external_source !== null) {
      this.dateField.predefined_external_source.active_paramn = this.dateField.predefined_external_source.parameters.length > 0 ? true : false;
      this.formulario.addControl('predefined_external_source', this.formBuilder.group({
        id: this.dateField.predefined_external_source.id,
        field_id: this.dateField.predefined_external_source.field_id,
        http_methods_type_id: this.dateField.predefined_external_source.http_methods_type_id,
        is_predefined_option: 1,
        link: this.dateField.predefined_external_source.link,
        auto_save: this.dateField.auto_save,
        parameters: this.formBuilder.array([], SlideToggleValidator.slideToggle()),
        active_paramn: [this.dateField.predefined_external_source.parameters.length > 0 ? true : false]
      }));
      if (this.dateField.predefined_external_source.parameters.length > 0) {
        this.addsPareamentsService.setValuesParametersTwo(this.dateField.predefined_external_source.parameters);
      }
      if (this.editorMode) {
        this.formulario.controls.predefined_external_source.disable();
        const controlPredefined: any = this.formulario.controls.predefined_external_source;
        setTimeout(() => {
          controlPredefined.controls.parameters.controls
            .forEach(control => {
              control.disable();
            });
        }, 500);
      }
    } else {
      this.formulario.addControl('predefined_external_source', this.createExternalSource(1));
    }
  }

  private createManualSource() {
    return this.formBuilder.array([]);
  }

  private createExternalSource(isPredefinedOption: number) {
    return this.formBuilder.group({
      id: [null],
      field_id: this.dateField.field_id,
      http_methods_type_id: [null],
      auto_save: [null],
      is_predefined_option: [isPredefinedOption],
      link: [null],
      parameters: this.formBuilder.array([], SlideToggleValidator.slideToggle()),
      active_paramn: [false]
    });
  }

  private getHttpMethods() {
    this.httpMethodsService.listAll().subscribe(
      data => {
        this.httpMethods = data;
      },
      error => {
        this.loaderService.setChangesLoaderState(false,
          error.body,
          '',
          'error',
          error.title,
          100000);
      }
    );
  }

  ngOnDestroy(): void {
    this.formulario.controls.predefined_source_options.enable();
    this.formulario.controls.defined_source.enable();
  }

  get f() { return this.formulario.controls; }

}
